import { useStartProjectModal } from "@/pages/Projects/composables/useStartProjectModal.composable";

import { loadProjectOverviewGuideSteps } from "../loadProjectOverviewGuideSteps";
import { existingUserSteps } from "../steps/existingUserSteps";
import { newUserSteps } from "../steps/newUserSteps";
import { WELCOME_FLOW_KEY } from "../welcomeFlow.config";
import { replayGuideStep } from "./replayGuideStep";
import type { WelcomeDeckWithFlow } from "./WelcomeDeck";

// The empty-state button takes over as the ending anchor when there are no projects yet.
const CREATE_PROJECT_ANCHOR_ID = "create-project-button";
const EMPTY_STATE_ANCHOR_ID = "empty-state-add-project-button";

export const platformDeck: WelcomeDeckWithFlow = {
  id: "platform",
  flowKey: WELCOME_FLOW_KEY,
  intro: {
    new: newUserSteps[0],
    existing: existingUserSteps[0],
  },
  celebrate: true,
  mandatory: true,
  loadSteps: async () => [...(await loadProjectOverviewGuideSteps()), replayGuideStep("projects-nav-link")],
  ending: {
    anchorId: CREATE_PROJECT_ANCHOR_ID,
    fallbackAnchorId: EMPTY_STATE_ANCHOR_ID,
    ctaLabel: (context) => (context.fallbackUsed ? "Create a project" : undefined),
    runCta: () => useStartProjectModal().openStartProjectModal(),
  },
};
